import { createAsyncThunk } from "@reduxjs/toolkit";
import { ColumnFiltersState } from "@tanstack/react-table";
import { ProcurementAxios } from "api/ProcurementAxios";



export const fetchProjectManagerDistrictInchargeMapping = createAsyncThunk(
  "procurement/fetchProjectManagerDistrictInchargeMapping",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search);
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }


    if (filters && filters.length > 0) {
      filters.forEach(
        ({
          filterField,
          filterValue,
        }: {
          filterField: string;
          filterValue: any;
        }) => {
          if (
            filterField &&
            filterValue !== undefined &&
            filterValue !== null
          ) {
            if (typeof filterValue === "object" && (filterField === "created_at" || filterField === "updated_at")) {
              const { from_date, to_date } = filterValue;

              // ✅ Set filter_by first
              params.append("filter_by", filterField);

              // ✅ Then set from_date and to_date
              if (from_date) params.append("from_date", String(from_date));
              if (to_date) params.append("to_date", String(to_date));
            } else {
              // Handle other filters
              if (filterField === "covered") {
                const booleanValue =
                  filterValue === "covered"
                    ? true
                    : filterValue === "uncovered"
                      ? false
                      : filterValue;
                params.append(filterField, String(booleanValue));
              } else {
                params.append(filterField, String(filterValue));
              }
            }
          }
        }
      );
    }

    const response: any = await ProcurementAxios.get(
      `/purchase-request/list/?${params.toString()}`
    );

    return {
      data: response?.data?.data || [],
      rowCount: response.data.count || 0,
    };
  }
);




export const exportPurchaseRequestCSV = createAsyncThunk(
  "suppliers/exportPurchaseRequestCSV",
  async (
    {
      filters,
    }: {
      filters?: ColumnFiltersState;
    },
    { rejectWithValue }
  ) => {
    try {
      const token = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "*/*",
      };

      const params: Record<string, any> = {
        export: "csv",
      };

      // Only apply column filters (not global search)
      if (filters && Array.isArray(filters)) {
        filters.forEach((filter) => {
          const { id, value } = filter;
          if (!id || value === undefined || value === "") return;

          if ((id === "updated_at" || id === "created_at") && typeof value === "object") {
            const { from_date, to_date } = value as { from_date?: string; to_date?: string };
            if (from_date) params["from_date"] = from_date;
            if (to_date) params["to_date"] = to_date;
          } else {
            params[id] = value;
          }
        });
      }

      const response = await ProcurementAxios.get("/purchase-request/list/?export=csv", {
        headers,
        params,
        responseType: "blob",
      });

      return {
        blob: response.data,
        filename:
          response.headers["content-disposition"]?.split("filename=")[1]?.replace(/"/g, "") ||
          "PurchaseRequest.csv",
      };
    } catch (err: any) {
      return rejectWithValue(err.message || "Failed to export CSV");
    }
  }
);



